export type CheckoutViewSettingsRaw = DeepPartial<{
  image_url: string;
  primary_color: string;
  secondary_color: string;
  shop_url: string;
  custom_script: string;
}>;

export type MerchantLanguageRaw = DeepPartial<{
  lang_name: string;
  lang_code: string;
}>;

export type MerchantLanguage = DeepPartial<{
  langName: string;
  langCode: string;
}>;

export type MerchantSettingsRaw = DeepPartial<{
  climate_compensation: boolean;
  currency: string;
  name: string;
  return_address1_note_attribute_name: string;
  shop_backend: ShopBackendRaw;
  show_store_credit: boolean;
  show_instant_store_credit: boolean;
  show_trade_in_items: boolean;
  merchant_languages: MerchantLanguageRaw[];
  shop_now_exchange_enabled: boolean;
  active_paypal_checkout: boolean;
}>;

export type CheckoutViewSettings = DeepPartial<{
  logoUrl: string;
  shopUrl: string;
  primaryColor: string;
  secondaryColor: string;
  customScript: string;
}>;

export type ShopBackendRaw = `${ShopBackend}`;

export enum ShopBackend {
  Shopify = "shopify_integration",
  Shopware = "shopware_integration",
}

export type MerchantSettings = DeepPartial<{
  climateCompensation: boolean;
  currency: string;
  name: string;
  shopBackend: ShopBackend; // TODO: remove later
  showStoreCredit: boolean;
  showInstantStoreCredit: boolean;
  returnAddressNoteAttributeName: string; // TODO: remove later
  showTradeInItems: boolean;
  shopNowEnabled: boolean;
  shopNowPaymentEnabled: boolean;
  merchantLanguages: MerchantLanguage[];
}>;
